// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".endpoint-tag[data-v-c1c52692]{display:inline-block}.endpoint-tag[data-v-c1c52692]:not(:first-of-type){margin:2px 4px 0 2px}.endpoint-link[data-v-c1c52692]:after{content:\", \";display:inline-block;color:var(--default-text)}.endpoint-link[data-v-c1c52692]:last-of-type:after{content:\"\"}", ""]);
// Exports
module.exports = exports;
